import styled from 'styled-components'
import { Breakpoints } from 'styles'

export const ResetPasswordComponent = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${Breakpoints.tablet}) {
    flex-direction: row;
  }
`

export const P = styled.p`
  margin-bottom: 40px;
  max-width: 85%;
`

export const StartCol = styled.div`
  max-width: 540px;
  flex-grow: 1;

  @media (min-width: ${Breakpoints.tablet}) {
    max-width: 540px;
    min-width: 375px;
    margin-inline-end: 75px;
  }

  @media (min-width: ${Breakpoints.desktop}) {
    min-width: 425px;
    margin-inline-end: 100px;
  }
`

export const EndCol = styled.div`
  max-width: 540px;
  margin-top: 36px;

  @media (min-width: ${Breakpoints.tablet}) {
    max-width: 380px;
    margin-top: 0;
  }
`
